export const PokedexText: {[k: string]: PokedexText} = {
	bulbasaur: {
		name: "Bulbasaur",
	},
	ivysaur: {
		name: "Ivysaur",
	},
	venusaur: {
		name: "Venusaur",
	},
	venusaurmega: {
		name: "Venusaur-Mega",
	},
	venusaurgmax: {
		name: "Venusaur-Gmax",
	},
	charmander: {
		name: "Charmander",
	},
	charmeleon: {
		name: "Charmeleon",
	},
	charizard: {
		name: "Charizard",
	},
	charizardmegax: {
		name: "Charizard-Mega-X",
	},
	charizardmegay: {
		name: "Charizard-Mega-Y",
	},
	charizardgmax: {
		name: "Charizard-Gmax",
	},
	squirtle: {
		name: "Squirtle",
	},
	wartortle: {
		name: "Wartortle",
	},
	blastoise: {
		name: "Blastoise",
	},
	blastoisemega: {
		name: "Blastoise-Mega",
	},
	blastoisegmax: {
		name: "Blastoise-Gmax",
	},
	caterpie: {
		name: "Caterpie",
	},
	metapod: {
		name: "Metapod",
	},
	butterfree: {
		name: "Butterfree",
	},
	butterfreegmax: {
		name: "Butterfree-Gmax",
	},
	weedle: {
		name: "Weedle",
	},
	kakuna: {
		name: "Kakuna",
	},
	beedrill: {
		name: "Beedrill",
	},
	beedrillmega: {
		name: "Beedrill-Mega",
	},
	pidgey: {
		name: "Pidgey",
	},
	pidgeotto: {
		name: "Pidgeotto",
	},
	pidgeot: {
		name: "Pidgeot",
	},
	pidgeotmega: {
		name: "Pidgeot-Mega",
	},
	rattata: {
		name: "Rattata",
	},
	rattataalola: {
		name: "Rattata-Alola",
	},
	raticate: {
		name: "Raticate",
	},
	raticatealola: {
		name: "Raticate-Alola",
	},
	raticatealolatotem: {
		name: "Raticate-Alola-Totem",
	},
	spearow: {
		name: "Spearow",
	},
	fearow: {
		name: "Fearow",
	},
	ekans: {
		name: "Ekans",
	},
	arbok: {
		name: "Arbok",
	},
	pikachu: {
		name: "Pikachu",
	},
	pikachucosplay: {
		name: "Pikachu-Cosplay",
	},
	pikachurockstar: {
		name: "Pikachu-Rock-Star",
	},
	pikachubelle: {
		name: "Pikachu-Belle",
	},
	pikachupopstar: {
		name: "Pikachu-Pop-Star",
	},
	pikachuphd: {
		name: "Pikachu-PhD",
	},
	pikachulibre: {
		name: "Pikachu-Libre",
	},
	pikachuoriginal: {
		name: "Pikachu-Original",
	},
	pikachuhoenn: {
		name: "Pikachu-Hoenn",
	},
	pikachusinnoh: {
		name: "Pikachu-Sinnoh",
	},
	pikachuunova: {
		name: "Pikachu-Unova",
	},
	pikachukalos: {
		name: "Pikachu-Kalos",
	},
	pikachualola: {
		name: "Pikachu-Alola",
	},
	pikachupartner: {
		name: "Pikachu-Partner",
	},
	pikachustarter: {
		name: "Pikachu-Starter",
	},
	pikachugmax: {
		name: "Pikachu-Gmax",
	},
	pikachuworld: {
		name: "Pikachu-World",
	},
	raichu: {
		name: "Raichu",
	},
	raichualola: {
		name: "Raichu-Alola",
	},
	sandshrew: {
		name: "Sandshrew",
	},
	sandshrewalola: {
		name: "Sandshrew-Alola",
	},
	sandslash: {
		name: "Sandslash",
	},
	sandslashalola: {
		name: "Sandslash-Alola",
	},
	nidoranf: {
		name: "Nidoran-F",
	},
	nidorina: {
		name: "Nidorina",
	},
	nidoqueen: {
		name: "Nidoqueen",
	},
	nidoranm: {
		name: "Nidoran-M",
	},
	nidorino: {
		name: "Nidorino",
	},
	nidoking: {
		name: "Nidoking",
	},
	clefairy: {
		name: "Clefairy",
	},
	clefable: {
		name: "Clefable",
	},
	vulpix: {
		name: "Vulpix",
	},
	vulpixalola: {
		name: "Vulpix-Alola",
	},
	ninetales: {
		name: "Ninetales",
	},
	ninetalesalola: {
		name: "Ninetales-Alola",
	},
	jigglypuff: {
		name: "Jigglypuff",
	},
	wigglytuff: {
		name: "Wigglytuff",
	},
	zubat: {
		name: "Zubat",
	},
	golbat: {
		name: "Golbat",
	},
	oddish: {
		name: "Oddish",
	},
	gloom: {
		name: "Gloom",
	},
	vileplume: {
		name: "Vileplume",
	},
	paras: {
		name: "Paras",
	},
	parasect: {
		name: "Parasect",
	},
	venonat: {
		name: "Venonat",
	},
	venomoth: {
		name: "Venomoth",
	},
	diglett: {
		name: "Diglett",
	},
	diglettalola: {
		name: "Diglett-Alola",
	},
	dugtrio: {
		name: "Dugtrio",
	},
	dugtrioalola: {
		name: "Dugtrio-Alola",
	},
	meowth: {
		name: "Meowth",
	},
	meowthalola: {
		name: "Meowth-Alola",
	},
	meowthgalar: {
		name: "Meowth-Galar",
	},
	meowthgmax: {
		name: "Meowth-Gmax",
	},
	persian: {
		name: "Persian",
	},
	persianalola: {
		name: "Persian-Alola",
	},
	psyduck: {
		name: "Psyduck",
	},
	golduck: {
		name: "Golduck",
	},
	mankey: {
		name: "Mankey",
	},
	primeape: {
		name: "Primeape",
	},
	growlithe: {
		name: "Growlithe",
	},
	growlithehisui: {
		name: "Growlithe-Hisui",
	},
	arcanine: {
		name: "Arcanine",
	},
	arcaninehisui: {
		name: "Arcanine-Hisui",
	},
	poliwag: {
		name: "Poliwag",
	},
	poliwhirl: {
		name: "Poliwhirl",
	},
	poliwrath: {
		name: "Poliwrath",
	},
	abra: {
		name: "Abra",
	},
	kadabra: {
		name: "Kadabra",
	},
	alakazam: {
		name: "Alakazam",
	},
	alakazammega: {
		name: "Alakazam-Mega",
	},
	machop: {
		name: "Machop",
	},
	machoke: {
		name: "Machoke",
	},
	machamp: {
		name: "Machamp",
	},
	machampgmax: {
		name: "Machamp-Gmax",
	},
	bellsprout: {
		name: "Bellsprout",
	},
	weepinbell: {
		name: "Weepinbell",
	},
	victreebel: {
		name: "Victreebel",
	},
	tentacool: {
		name: "Tentacool",
	},
	tentacruel: {
		name: "Tentacruel",
	},
	geodude: {
		name: "Geodude",
	},
	geodudealola: {
		name: "Geodude-Alola",
	},
	graveler: {
		name: "Graveler",
	},
	graveleralola: {
		name: "Graveler-Alola",
	},
	golem: {
		name: "Golem",
	},
	golemalola: {
		name: "Golem-Alola",
	},
	ponyta: {
		name: "Ponyta",
	},
	ponytagalar: {
		name: "Ponyta-Galar",
	},
	rapidash: {
		name: "Rapidash",
	},
	rapidashgalar: {
		name: "Rapidash-Galar",
	},
	slowpoke: {
		name: "Slowpoke",
	},
	slowpokegalar: {
		name: "Slowpoke-Galar",
	},
	slowbro: {
		name: "Slowbro",
	},
	slowbromega: {
		name: "Slowbro-Mega",
	},
	slowbrogalar: {
		name: "Slowbro-Galar",
	},
	magnemite: {
		name: "Magnemite",
	},
	magneton: {
		name: "Magneton",
	},
	farfetchd: {
		name: "Farfetch\u2019d",
	},
	farfetchdgalar: {
		name: "Farfetch\u2019d-Galar",
	},
	doduo: {
		name: "Doduo",
	},
	dodrio: {
		name: "Dodrio",
	},
	seel: {
		name: "Seel",
	},
	dewgong: {
		name: "Dewgong",
	},
	grimer: {
		name: "Grimer",
	},
	grimeralola: {
		name: "Grimer-Alola",
	},
	muk: {
		name: "Muk",
	},
	mukalola: {
		name: "Muk-Alola",
	},
	shellder: {
		name: "Shellder",
	},
	cloyster: {
		name: "Cloyster",
	},
	gastly: {
		name: "Gastly",
	},
	haunter: {
		name: "Haunter",
	},
	gengar: {
		name: "Gengar",
	},
	gengarmega: {
		name: "Gengar-Mega",
	},
	gengargmax: {
		name: "Gengar-Gmax",
	},
	onix: {
		name: "Onix",
	},
	drowzee: {
		name: "Drowzee",
	},
	hypno: {
		name: "Hypno",
	},
	krabby: {
		name: "Krabby",
	},
	kingler: {
		name: "Kingler",
	},
	kinglergmax: {
		name: "Kingler-Gmax",
	},
	voltorb: {
		name: "Voltorb",
	},
	voltorbhisui: {
		name: "Voltorb-Hisui",
	},
	electrode: {
		name: "Electrode",
	},
	electrodehisui: {
		name: "Electrode-Hisui",
	},
	exeggcute: {
		name: "Exeggcute",
	},
	exeggutor: {
		name: "Exeggutor",
	},
	exeggutoralola: {
		name: "Exeggutor-Alola",
	},
	cubone: {
		name: "Cubone",
	},
	marowak: {
		name: "Marowak",
	},
	marowakalola: {
		name: "Marowak-Alola",
	},
	marowakalolatotem: {
		name: "Marowak-Alola-Totem",
	},
	hitmonlee: {
		name: "Hitmonlee",
	},
	hitmonchan: {
		name: "Hitmonchan",
	},
	lickitung: {
		name: "Lickitung",
	},
	koffing: {
		name: "Koffing",
	},
	weezing: {
		name: "Weezing",
	},
	weezinggalar: {
		name: "Weezing-Galar",
	},
	rhyhorn: {
		name: "Rhyhorn",
	},
	rhydon: {
		name: "Rhydon",
	},
	chansey: {
		name: "Chansey",
	},
	tangela: {
		name: "Tangela",
	},
	kangaskhan: {
		name: "Kangaskhan",
	},
	kangaskhanmega: {
		name: "Kangaskhan-Mega",
	},
	horsea: {
		name: "Horsea",
	},
	seadra: {
		name: "Seadra",
	},
	goldeen: {
		name: "Goldeen",
	},
	seaking: {
		name: "Seaking",
	},
	staryu: {
		name: "Staryu",
	},
	starmie: {
		name: "Starmie",
	},
	mrmime: {
		name: "Mr. Mime",
	},
	mrmimegalar: {
		name: "Mr. Mime-Galar",
	},
	scyther: {
		name: "Scyther",
	},
	jynx: {
		name: "Jynx",
	},
	electabuzz: {
		name: "Electabuzz",
	},
	magmar: {
		name: "Magmar",
	},
	pinsir: {
		name: "Pinsir",
	},
	pinsirmega: {
		name: "Pinsir-Mega",
	},
	tauros: {
		name: "Tauros",
	},
	magikarp: {
		name: "Magikarp",
	},
	gyarados: {
		name: "Gyarados",
	},
	gyaradosmega: {
		name: "Gyarados-Mega",
	},
	lapras: {
		name: "Lapras",
	},
	laprasgmax: {
		name: "Lapras-Gmax",
	},
	ditto: {
		name: "Ditto",
	},
	eevee: {
		name: "Eevee",
	},
	eeveestarter: {
		name: "Eevee-Starter",
	},
	eeveegmax: {
		name: "Eevee-Gmax",
	},
	vaporeon: {
		name: "Vaporeon",
	},
	jolteon: {
		name: "Jolteon",
	},
	flareon: {
		name: "Flareon",
	},
	porygon: {
		name: "Porygon",
	},
	omanyte: {
		name: "Omanyte",
	},
	omastar: {
		name: "Omastar",
	},
	kabuto: {
		name: "Kabuto",
	},
	kabutops: {
		name: "Kabutops",
	},
	aerodactyl: {
		name: "Aerodactyl",
	},
	aerodactylmega: {
		name: "Aerodactyl-Mega",
	},
	snorlax: {
		name: "Snorlax",
	},
	snorlaxgmax: {
		name: "Snorlax-Gmax",
	},
	articuno: {
		name: "Articuno",
	},
	zapdos: {
		name: "Zapdos",
	},
	moltres: {
		name: "Moltres",
	},
	dratini: {
		name: "Dratini",
	},
	dragonair: {
		name: "Dragonair",
	},
	dragonite: {
		name: "Dragonite",
	},
	mewtwo: {
		name: "Mewtwo",
	},
	mewtwomegax: {
		name: "Mewtwo-Mega-X",
	},
	mewtwomegay: {
		name: "Mewtwo-Mega-Y",
	},
	mew: {
		name: "Mew",
	},
	chikorita: {
		name: "Chikorita",
	},
	bayleef: {
		name: "Bayleef",
	},
	meganium: {
		name: "Meganium",
	},
	cyndaquil: {
		name: "Cyndaquil",
	},
	quilava: {
		name: "Quilava",
	},
	typhlosion: {
		name: "Typhlosion",
	},
	typhlosionhisui: {
		name: "Typhlosion-Hisui",
	},
	totodile: {
		name: "Totodile",
	},
	croconaw: {
		name: "Croconaw",
	},
	feraligatr: {
		name: "Feraligatr",
	},
	sentret: {
		name: "Sentret",
	},
	furret: {
		name: "Furret",
	},
	hoothoot: {
		name: "Hoothoot",
	},
	noctowl: {
		name: "Noctowl",
	},
	ledyba: {
		name: "Ledyba",
	},
	ledian: {
		name: "Ledian",
	},
	spinarak: {
		name: "Spinarak",
	},
	ariados: {
		name: "Ariados",
	},
	crobat: {
		name: "Crobat",
	},
	chinchou: {
		name: "Chinchou",
	},
	lanturn: {
		name: "Lanturn",
	},
	pichu: {
		name: "Pichu",
	},
	pichuspikyeared: {
		name: "Pichu-Spiky-eared",
	},
	cleffa: {
		name: "Cleffa",
	},
	igglybuff: {
		name: "Igglybuff",
	},
	togepi: {
		name: "Togepi",
	},
	togetic: {
		name: "Togetic",
	},
	natu: {
		name: "Natu",
	},
	xatu: {
		name: "Xatu",
	},
	mareep: {
		name: "Mareep",
	},
	flaaffy: {
		name: "Flaaffy",
	},
	ampharos: {
		name: "Ampharos",
	},
	ampharosmega: {
		name: "Ampharos-Mega",
	},
	bellossom: {
		name: "Bellossom",
	},
	marill: {
		name: "Marill",
	},
	azumarill: {
		name: "Azumarill",
	},
	sudowoodo: {
		name: "Sudowoodo",
	},
	politoed: {
		name: "Politoed",
	},
	hoppip: {
		name: "Hoppip",
	},
	skiploom: {
		name: "Skiploom",
	},
	jumpluff: {
		name: "Jumpluff",
	},
	aipom: {
		name: "Aipom",
	},
	sunkern: {
		name: "Sunkern",
	},
	sunflora: {
		name: "Sunflora",
	},
	yanma: {
		name: "Yanma",
	},
	wooper: {
		name: "Wooper",
	},
	wooperpaldea: {
		name: "Wooper-Paldea",
	},
	quagsire: {
		name: "Quagsire",
	},
	quagsirepaldea: {
		name: "Quagsire-Paldea",
	},
	espeon: {
		name: "Espeon",
	},
	umbreon: {
		name: "Umbreon",
	},
	murkrow: {
		name: "Murkrow",
	},
	slowking: {
		name: "Slowking",
	},
	misdreavus: {
		name: "Misdreavus",
	},
	unown: {
		name: "Unown",
	},
	wobbuffet: {
		name: "Wobbuffet",
	},
	girafarig: {
		name: "Girafarig",
	},
	pineco: {
		name: "Pineco",
	},
	forretress: {
		name: "Forretress",
	},
	dunsparce: {
		name: "Dunsparce",
	},
	gligar: {
		name: "Gligar",
	},
	steelix: {
		name: "Steelix",
	},
	steelixmega: {
		name: "Steelix-Mega",
	},
	snubbull: {
		name: "Snubbull",
	},
	granbull: {
		name: "Granbull",
	},
	qwilfish: {
		name: "Qwilfish",
	},
	qwilfishhisui: {
		name: "Qwilfish-Hisui",
	},
	scizor: {
		name: "Scizor",
	},
	scizormega: {
		name: "Scizor-Mega",
	},
	shuckle: {
		name: "Shuckle",
	},
	heracross: {
		name: "Heracross",
	},
	heracrossmega: {
		name: "Heracross-Mega",
	},
	sneasel: {
		name: "Sneasel",
	},
	sneaselhisui: {
		name: "Sneasel-Hisui",
	},
	teddiursa: {
		name: "Teddiursa",
	},
	ursaring: {
		name: "Ursaring",
	},
	slugma: {
		name: "Slugma",
	},
	magcargo: {
		name: "Magcargo",
	},
	swinub: {
		name: "Swinub",
	},
	piloswine: {
		name: "Piloswine",
	},
	corsola: {
		name: "Corsola",
	},
	corsolagalar: {
		name: "Corsola-Galar",
	},
	remoraid: {
		name: "Remoraid",
	},
	octillery: {
		name: "Octillery",
	},
	delibird: {
		name: "Delibird",
	},
	mantine: {
		name: "Mantine",
	},
	skarmory: {
		name: "Skarmory",
	},
	houndour: {
		name: "Houndour",
	},
	houndoom: {
		name: "Houndoom",
	},
	houndoommega: {
		name: "Houndoom-Mega",
	},
	kingdra: {
		name: "Kingdra",
	},
	phanpy: {
		name: "Phanpy",
	},
	donphan: {
		name: "Donphan",
	},
	porygon2: {
		name: "Porygon2",
	},
	stantler: {
		name: "Stantler",
	},
	smeargle: {
		name: "Smeargle",
	},
	tyrogue: {
		name: "Tyrogue",
	},
	hitmontop: {
		name: "Hitmontop",
	},
	smoochum: {
		name: "Smoochum",
	},
	elekid: {
		name: "Elekid",
	},
	magby: {
		name: "Magby",
	},
	miltank: {
		name: "Miltank",
	},
	blissey: {
		name: "Blissey",
	},
	raikou: {
		name: "Raikou",
	},
	entei: {
		name: "Entei",
	},
	suicune: {
		name: "Suicune",
	},
	larvitar: {
		name: "Larvitar",
	},
	pupitar: {
		name: "Pupitar",
	},
	tyranitar: {
		name: "Tyranitar",
	},
	tyranitarmega: {
		name: "Tyranitar-Mega",
	},
	lugia: {
		name: "Lugia",
	},
	hooh: {
		name: "Ho-Oh",
	},
	celebi: {
		name: "Celebi",
	},
	treecko: {
		name: "Treecko",
	},
	grovyle: {
		name: "Grovyle",
	},
	sceptile: {
		name: "Sceptile",
	},
	sceptilemega: {
		name: "Sceptile-Mega",
	},
	torchic: {
		name: "Torchic",
	},
	combusken: {
		name: "Combusken",
	},
	blaziken: {
		name: "Blaziken",
	},
	blazikenmega: {
		name: "Blaziken-Mega",
	},
	mudkip: {
		name: "Mudkip",
	},
	marshtomp: {
		name: "Marshtomp",
	},
	swampert: {
		name: "Swampert",
	},
	swampertmega: {
		name: "Swampert-Mega",
	},
	poochyena: {
		name: "Poochyena",
	},
	mightyena: {
		name: "Mightyena",
	},
	zigzagoon: {
		name: "Zigzagoon",
	},
	zigzagoongalar: {
		name: "Zigzagoon-Galar",
	},
	linoone: {
		name: "Linoone",
	},
	linoonegalar: {
		name: "Linoone-Galar",
	},
	wurmple: {
		name: "Wurmple",
	},
	silcoon: {
		name: "Silcoon",
	},
	beautifly: {
		name: "Beautifly",
	},
	cascoon: {
		name: "Cascoon",
	},
	dustox: {
		name: "Dustox",
	},
	lotad: {
		name: "Lotad",
	},
	lombre: {
		name: "Lombre",
	},
	ludicolo: {
		name: "Ludicolo",
	},
	seedot: {
		name: "Seedot",
	},
	nuzleaf: {
		name: "Nuzleaf",
	},
	shiftry: {
		name: "Shiftry",
	},
	taillow: {
		name: "Taillow",
	},
	swellow: {
		name: "Swellow",
	},
	wingull: {
		name: "Wingull",
	},
	pelipper: {
		name: "Pelipper",
	},
	ralts: {
		name: "Ralts",
	},
	kirlia: {
		name: "Kirlia",
	},
	gardevoir: {
		name: "Gardevoir",
	},
	gardevoirmega: {
		name: "Gardevoir-Mega",
	},
	surskit: {
		name: "Surskit",
	},
	masquerain: {
		name: "Masquerain",
	},
	shroomish: {
		name: "Shroomish",
	},
	breloom: {
		name: "Breloom",
	},
	slakoth: {
		name: "Slakoth",
	},
	vigoroth: {
		name: "Vigoroth",
	},
	slaking: {
		name: "Slaking",
	},
	nincada: {
		name: "Nincada",
	},
	ninjask: {
		name: "Ninjask",
	},
	shedinja: {
		name: "Shedinja",
	},
	whismur: {
		name: "Whismur",
	},
	loudred: {
		name: "Loudred",
	},
	exploud: {
		name: "Exploud",
	},
	makuhita: {
		name: "Makuhita",
	},
	hariyama: {
		name: "Hariyama",
	},
	azurill: {
		name: "Azurill",
	},
	nosepass: {
		name: "Nosepass",
	},
	skitty: {
		name: "Skitty",
	},
	delcatty: {
		name: "Delcatty",
	},
	sableye: {
		name: "Sableye",
	},
	sableyemega: {
		name: "Sableye-Mega",
	},
	mawile: {
		name: "Mawile",
	},
	mawilemega: {
		name: "Mawile-Mega",
	},
	aron: {
		name: "Aron",
	},
	lairon: {
		name: "Lairon",
	},
	aggron: {
		name: "Aggron",
	},
	aggronmega: {
		name: "Aggron-Mega",
	},
	meditite: {
		name: "Meditite",
	},
	medicham: {
		name: "Medicham",
	},
	medichammega: {
		name: "Medicham-Mega",
	},
	electrike: {
		name: "Electrike",
	},
	manectric: {
		name: "Manectric",
	},
	manectricmega: {
		name: "Manectric-Mega",
	},
	plusle: {
		name: "Plusle",
	},
	minun: {
		name: "Minun",
	},
	volbeat: {
		name: "Volbeat",
	},
	illumise: {
		name: "Illumise",
	},
	roselia: {
		name: "Roselia",
	},
	gulpin: {
		name: "Gulpin",
	},
	swalot: {
		name: "Swalot",
	},
	carvanha: {
		name: "Carvanha",
	},
	sharpedo: {
		name: "Sharpedo",
	},
	sharpedomega: {
		name: "Sharpedo-Mega",
	},
	wailmer: {
		name: "Wailmer",
	},
	wailord: {
		name: "Wailord",
	},
	numel: {
		name: "Numel",
	},
	camerupt: {
		name: "Camerupt",
	},
	cameruptmega: {
		name: "Camerupt-Mega",
	},
	torkoal: {
		name: "Torkoal",
	},
	spoink: {
		name: "Spoink",
	},
	grumpig: {
		name: "Grumpig",
	},
	spinda: {
		name: "Spinda",
	},
	trapinch: {
		name: "Trapinch",
	},
	vibrava: {
		name: "Vibrava",
	},
	flygon: {
		name: "Flygon",
	},
	cacnea: {
		name: "Cacnea",
	},
	cacturne: {
		name: "Cacturne",
	},
	swablu: {
		name: "Swablu",
	},
	altaria: {
		name: "Altaria",
	},
	altariamega: {
		name: "Altaria-Mega",
	},
	zangoose: {
		name: "Zangoose",
	},
	seviper: {
		name: "Seviper",
	},
	lunatone: {
		name: "Lunatone",
	},
	solrock: {
		name: "Solrock",
	},
	barboach: {
		name: "Barboach",
	},
	whiscash: {
		name: "Whiscash",
	},
	corphish: {
		name: "Corphish",
	},
	crawdaunt: {
		name: "Crawdaunt",
	},
	baltoy: {
		name: "Baltoy",
	},
	claydol: {
		name: "Claydol",
	},
	lileep: {
		name: "Lileep",
	},
	cradily: {
		name: "Cradily",
	},
	anorith: {
		name: "Anorith",
	},
	armaldo: {
		name: "Armaldo",
	},
	feebas: {
		name: "Feebas",
	},
	milotic: {
		name: "Milotic",
	},
	castform: {
		name: "Castform",
	},
	castformsunny: {
		name: "Castform-Sunny",
	},
	castformrainy: {
		name: "Castform-Rainy",
	},
	castformsnowy: {
		name: "Castform-Snowy",
	},
	kecleon: {
		name: "Kecleon",
	},
	shuppet: {
		name: "Shuppet",
	},
	banette: {
		name: "Banette",
	},
	banettemega: {
		name: "Banette-Mega",
	},
	duskull: {
		name: "Duskull",
	},
	dusclops: {
		name: "Dusclops",
	},
	tropius: {
		name: "Tropius",
	},
	chimecho: {
		name: "Chimecho",
	},
	absol: {
		name: "Absol",
	},
	absolmega: {
		name: "Absol-Mega",
	},
	wynaut: {
		name: "Wynaut",
	},
	snorunt: {
		name: "Snorunt",
	},
	glalie: {
		name: "Glalie",
	},
	glaliemega: {
		name: "Glalie-Mega",
	},
	spheal: {
		name: "Spheal",
	},
	sealeo: {
		name: "Sealeo",
	},
	walrein: {
		name: "Walrein",
	},
	clamperl: {
		name: "Clamperl",
	},
	huntail: {
		name: "Huntail",
	},
	gorebyss: {
		name: "Gorebyss",
	},
	relicanth: {
		name: "Relicanth",
	},
	luvdisc: {
		name: "Luvdisc",
	},
	bagon: {
		name: "Bagon",
	},
	shelgon: {
		name: "Shelgon",
	},
	salamence: {
		name: "Salamence",
	},
	salamencemega: {
		name: "Salamence-Mega",
	},
	beldum: {
		name: "Beldum",
	},
	metang: {
		name: "Metang",
	},
	metagross: {
		name: "Metagross",
	},
	metagrossmega: {
		name: "Metagross-Mega",
	},
	regirock: {
		name: "Regirock",
	},
	regice: {
		name: "Regice",
	},
	registeel: {
		name: "Registeel",
	},
	latias: {
		name: "Latias",
	},
	latiasmega: {
		name: "Latias-Mega",
	},
	latios: {
		name: "Latios",
	},
	latiosmega: {
		name: "Latios-Mega",
	},
	kyogre: {
		name: "Kyogre",
	},
	kyogreprimal: {
		name: "Kyogre-Primal",
	},
	groudon: {
		name: "Groudon",
	},
	groudonprimal: {
		name: "Groudon-Primal",
	},
	rayquaza: {
		name: "Rayquaza",
	},
	rayquazamega: {
		name: "Rayquaza-Mega",
	},
	jirachi: {
		name: "Jirachi",
	},
	deoxys: {
		name: "Deoxys",
	},
	deoxysattack: {
		name: "Deoxys-Attack",
	},
	deoxysdefense: {
		name: "Deoxys-Defense",
	},
	deoxysspeed: {
		name: "Deoxys-Speed",
	},
	turtwig: {
		name: "Turtwig",
	},
	grotle: {
		name: "Grotle",
	},
	torterra: {
		name: "Torterra",
	},
	chimchar: {
		name: "Chimchar",
	},
	monferno: {
		name: "Monferno",
	},
	infernape: {
		name: "Infernape",
	},
	piplup: {
		name: "Piplup",
	},
	prinplup: {
		name: "Prinplup",
	},
	empoleon: {
		name: "Empoleon",
	},
	starly: {
		name: "Starly",
	},
	staravia: {
		name: "Staravia",
	},
	staraptor: {
		name: "Staraptor",
	},
	bidoof: {
		name: "Bidoof",
	},
	bibarel: {
		name: "Bibarel",
	},
	kricketot: {
		name: "Kricketot",
	},
	kricketune: {
		name: "Kricketune",
	},
	shinx: {
		name: "Shinx",
	},
	luxio: {
		name: "Luxio",
	},
	luxray: {
		name: "Luxray",
	},
	budew: {
		name: "Budew",
	},
	roserade: {
		name: "Roserade",
	},
	cranidos: {
		name: "Cranidos",
	},
	rampardos: {
		name: "Rampardos",
	},
	shieldon: {
		name: "Shieldon",
	},
	bastiodon: {
		name: "Bastiodon",
	},
	burmy: {
		name: "Burmy",
	},
	wormadam: {
		name: "Wormadam",
	},
	wormadamsandy: {
		name: "Wormadam-Sandy",
	},
	wormadamtrash: {
		name: "Wormadam-Trash",
	},
	mothim: {
		name: "Mothim",
	},
	combee: {
		name: "Combee",
	},
	vespiquen: {
		name: "Vespiquen",
	},
	pachirisu: {
		name: "Pachirisu",
	},
	buizel: {
		name: "Buizel",
	},
	floatzel: {
		name: "Floatzel",
	},
	cherubi: {
		name: "Cherubi",
	},
	cherrim: {
		name: "Cherrim",
	},
	cherrimsunshine: {
		name: "Cherrim-Sunshine",
	},
	shellos: {
		name: "Shellos",
	},
	gastrodon: {
		name: "Gastrodon",
	},
	ambipom: {
		name: "Ambipom",
	},
	drifloon: {
		name: "Drifloon",
	},
	drifblim: {
		name: "Drifblim",
	},
	buneary: {
		name: "Buneary",
	},
	lopunny: {
		name: "Lopunny",
	},
	lopunnymega: {
		name: "Lopunny-Mega",
	},
	mismagius: {
		name: "Mismagius",
	},
	honchkrow: {
		name: "Honchkrow",
	},
	glameow: {
		name: "Glameow",
	},
	purugly: {
		name: "Purugly",
	},
	chingling: {
		name: "Chingling",
	},
	stunky: {
		name: "Stunky",
	},
	skuntank: {
		name: "Skuntank",
	},
	bronzor: {
		name: "Bronzor",
	},
	bronzong: {
		name: "Bronzong",
	},
	bonsly: {
		name: "Bonsly",
	},
	mimejr: {
		name: "Mime Jr.",
	},
	happiny: {
		name: "Happiny",
	},
	chatot: {
		name: "Chatot",
	},
	spiritomb: {
		name: "Spiritomb",
	},
	gible: {
		name: "Gible",
	},
	gabite: {
		name: "Gabite",
	},
	garchomp: {
		name: "Garchomp",
	},
	garchompmega: {
		name: "Garchomp-Mega",
	},
	munchlax: {
		name: "Munchlax",
	},
	riolu: {
		name: "Riolu",
	},
	lucario: {
		name: "Lucario",
	},
	lucariomega: {
		name: "Lucario-Mega",
	},
	hippopotas: {
		name: "Hippopotas",
	},
	hippowdon: {
		name: "Hippowdon",
	},
	skorupi: {
		name: "Skorupi",
	},
	drapion: {
		name: "Drapion",
	},
	croagunk: {
		name: "Croagunk",
	},
	toxicroak: {
		name: "Toxicroak",
	},
	carnivine: {
		name: "Carnivine",
	},
	finneon: {
		name: "Finneon",
	},
	lumineon: {
		name: "Lumineon",
	},
	mantyke: {
		name: "Mantyke",
	},
	snover: {
		name: "Snover",
	},
	abomasnow: {
		name: "Abomasnow",
	},
	abomasnowmega: {
		name: "Abomasnow-Mega",
	},
	weavile: {
		name: "Weavile",
	},
	magnezone: {
		name: "Magnezone",
	},
	lickilicky: {
		name: "Lickilicky",
	},
	rhyperior: {
		name: "Rhyperior",
	},
	tangrowth: {
		name: "Tangrowth",
	},
	electivire: {
		name: "Electivire",
	},
	magmortar: {
		name: "Magmortar",
	},
	togekiss: {
		name: "Togekiss",
	},
	yanmega: {
		name: "Yanmega",
	},
	leafeon: {
		name: "Leafeon",
	},
	glaceon: {
		name: "Glaceon",
	},
	gliscor: {
		name: "Gliscor",
	},
	mamoswine: {
		name: "Mamoswine",
	},
	porygonz: {
		name: "Porygon-Z",
	},
	gallade: {
		name: "Gallade",
	},
	gallademega: {
		name: "Gallade-Mega",
	},
	probopass: {
		name: "Probopass",
	},
	dusknoir: {
		name: "Dusknoir",
	},
	froslass: {
		name: "Froslass",
	},
	rotom: {
		name: "Rotom",
	},
	rotomheat: {
		name: "Rotom-Heat",
	},
	rotomwash: {
		name: "Rotom-Wash",
	},
	rotomfrost: {
		name: "Rotom-Frost",
	},
	rotomfan: {
		name: "Rotom-Fan",
	},
	rotommow: {
		name: "Rotom-Mow",
	},
	uxie: {
		name: "Uxie",
	},
	mesprit: {
		name: "Mesprit",
	},
	azelf: {
		name: "Azelf",
	},
	dialga: {
		name: "Dialga",
	},
	dialgaorigin: {
		name: "Dialga-Origin",
	},
	palkia: {
		name: "Palkia",
	},
	palkiaorigin: {
		name: "Palkia-Origin",
	},
	heatran: {
		name: "Heatran",
	},
	regigigas: {
		name: "Regigigas",
	},
	giratina: {
		name: "Giratina",
	},
	giratinaorigin: {
		name: "Giratina-Origin",
	},
	cresselia: {
		name: "Cresselia",
	},
	phione: {
		name: "Phione",
	},
	manaphy: {
		name: "Manaphy",
	},
	darkrai: {
		name: "Darkrai",
	},
	shaymin: {
		name: "Shaymin",
	},
	shayminsky: {
		name: "Shaymin-Sky",
	},
	arceus: {
		name: "Arceus",
	},
	arceusbug: {
		name: "Arceus-Bug",
	},
	arceusdark: {
		name: "Arceus-Dark",
	},
	arceusdragon: {
		name: "Arceus-Dragon",
	},
	arceuselectric: {
		name: "Arceus-Electric",
	},
	arceusfairy: {
		name: "Arceus-Fairy",
	},
	arceusfighting: {
		name: "Arceus-Fighting",
	},
	arceusfire: {
		name: "Arceus-Fire",
	},
	arceusflying: {
		name: "Arceus-Flying",
	},
	arceusghost: {
		name: "Arceus-Ghost",
	},
	arceusgrass: {
		name: "Arceus-Grass",
	},
	arceusground: {
		name: "Arceus-Ground",
	},
	arceusice: {
		name: "Arceus-Ice",
	},
	arceuspoison: {
		name: "Arceus-Poison",
	},
	arceuspsychic: {
		name: "Arceus-Psychic",
	},
	arceusrock: {
		name: "Arceus-Rock",
	},
	arceussteel: {
		name: "Arceus-Steel",
	},
	arceuswater: {
		name: "Arceus-Water",
	},
	victini: {
		name: "Victini",
	},
	snivy: {
		name: "Snivy",
	},
	servine: {
		name: "Servine",
	},
	serperior: {
		name: "Serperior",
	},
	tepig: {
		name: "Tepig",
	},
	pignite: {
		name: "Pignite",
	},
	emboar: {
		name: "Emboar",
	},
	oshawott: {
		name: "Oshawott",
	},
	dewott: {
		name: "Dewott",
	},
	samurott: {
		name: "Samurott",
	},
	samurotthisui: {
		name: "Samurott-Hisui",
	},
	patrat: {
		name: "Patrat",
	},
	watchog: {
		name: "Watchog",
	},
	lillipup: {
		name: "Lillipup",
	},
	herdier: {
		name: "Herdier",
	},
	stoutland: {
		name: "Stoutland",
	},
	purrloin: {
		name: "Purrloin",
	},
	liepard: {
		name: "Liepard",
	},
	pansage: {
		name: "Pansage",
	},
	simisage: {
		name: "Simisage",
	},
	pansear: {
		name: "Pansear",
	},
	simisear: {
		name: "Simisear",
	},
	panpour: {
		name: "Panpour",
	},
	simipour: {
		name: "Simipour",
	},
	munna: {
		name: "Munna",
	},
	musharna: {
		name: "Musharna",
	},
	pidove: {
		name: "Pidove",
	},
	tranquill: {
		name: "Tranquill",
	},
	unfezant: {
		name: "Unfezant",
	},
	blitzle: {
		name: "Blitzle",
	},
	zebstrika: {
		name: "Zebstrika",
	},
	roggenrola: {
		name: "Roggenrola",
	},
	boldore: {
		name: "Boldore",
	},
	gigalith: {
		name: "Gigalith",
	},
	woobat: {
		name: "Woobat",
	},
	swoobat: {
		name: "Swoobat",
	},
	drilbur: {
		name: "Drilbur",
	},
	excadrill: {
		name: "Excadrill",
	},
	audino: {
		name: "Audino",
	},
	audinomega: {
		name: "Audino-Mega",
	},
	timburr: {
		name: "Timburr",
	},
	gurdurr: {
		name: "Gurdurr",
	},
	conkeldurr: {
		name: "Conkeldurr",
	},
	tympole: {
		name: "Tympole",
	},
	palpitoad: {
		name: "Palpitoad",
	},
	seismitoad: {
		name: "Seismitoad",
	},
	throh: {
		name: "Throh",
	},
	sawk: {
		name: "Sawk",
	},
	sewaddle: {
		name: "Sewaddle",
	},
	swadloon: {
		name: "Swadloon",
	},
	leavanny: {
		name: "Leavanny",
	},
	venipede: {
		name: "Venipede",
	},
	whirlipede: {
		name: "Whirlipede",
	},
	scolipede: {
		name: "Scolipede",
	},
	cottonee: {
		name: "Cottonee",
	},
	whimsicott: {
		name: "Whimsicott",
	},
	petilil: {
		name: "Petilil",
	},
	lilligant: {
		name: "Lilligant",
	},
	lilliganthisui: {
		name: "Lilligant-Hisui",
	},
	basculin: {
		name: "Basculin",
	},
	basculinbluestriped: {
		name: "Basculin-Blue-Striped",
	},
	basculinwhitestriped: {
		name: "Basculin-White-Striped",
	},
	sandile: {
		name: "Sandile",
	},
	krokorok: {
		name: "Krokorok",
	},
	krookodile: {
		name: "Krookodile",
	},
	darumaka: {
		name: "Darumaka",
	},
	darumakagalar: {
		name: "Darumaka-Galar",
	},
	darmanitan: {
		name: "Darmanitan",
	},
	darmanitanzen: {
		name: "Darmanitan-Zen",
	},
	darmanitangalar: {
		name: "Darmanitan-Galar",
	},
	darmanitangalarzen: {
		name: "Darmanitan-Galar-Zen",
	},
	maractus: {
		name: "Maractus",
	},
	dwebble: {
		name: "Dwebble",
	},
	crustle: {
		name: "Crustle",
	},
	scraggy: {
		name: "Scraggy",
	},
	scrafty: {
		name: "Scrafty",
	},
	sigilyph: {
		name: "Sigilyph",
	},
	yamask: {
		name: "Yamask",
	},
	yamaskgalar: {
		name: "Yamask-Galar",
	},
	cofagrigus: {
		name: "Cofagrigus",
	},
	tirtouga: {
		name: "Tirtouga",
	},
	carracosta: {
		name: "Carracosta",
	},
	archen: {
		name: "Archen",
	},
	archeops: {
		name: "Archeops",
	},
	trubbish: {
		name: "Trubbish",
	},
	garbodor: {
		name: "Garbodor",
	},
	garbodorgmax: {
		name: "Garbodor-Gmax",
	},
	zorua: {
		name: "Zorua",
	},
	zoruahisui: {
		name: "Zorua-Hisui",
	},
	zoroark: {
		name: "Zoroark",
	},
	zoroarkhisui: {
		name: "Zoroark-Hisui",
	},
	minccino: {
		name: "Minccino",
	},
	cinccino: {
		name: "Cinccino",
	},
	gothita: {
		name: "Gothita",
	},
	gothorita: {
		name: "Gothorita",
	},
	gothitelle: {
		name: "Gothitelle",
	},
	solosis: {
		name: "Solosis",
	},
	duosion: {
		name: "Duosion",
	},
	reuniclus: {
		name: "Reuniclus",
	},
	ducklett: {
		name: "Ducklett",
	},
	swanna: {
		name: "Swanna",
	},
	vanillite: {
		name: "Vanillite",
	},
	vanillish: {
		name: "Vanillish",
	},
	vanilluxe: {
		name: "Vanilluxe",
	},
	deerling: {
		name: "Deerling",
	},
	sawsbuck: {
		name: "Sawsbuck",
	},
	emolga: {
		name: "Emolga",
	},
	karrablast: {
		name: "Karrablast",
	},
	escavalier: {
		name: "Escavalier",
	},
	foongus: {
		name: "Foongus",
	},
	amoonguss: {
		name: "Amoonguss",
	},
	frillish: {
		name: "Frillish",
	},
	jellicent: {
		name: "Jellicent",
	},
	alomomola: {
		name: "Alomomola",
	},
	joltik: {
		name: "Joltik",
	},
	galvantula: {
		name: "Galvantula",
	},
	ferroseed: {
		name: "Ferroseed",
	},
	ferrothorn: {
		name: "Ferrothorn",
	},
	klink: {
		name: "Klink",
	},
	klang: {
		name: "Klang",
	},
	klinklang: {
		name: "Klinklang",
	},
	tynamo: {
		name: "Tynamo",
	},
	eelektrik: {
		name: "Eelektrik",
	},
	eelektross: {
		name: "Eelektross",
	},
	elgyem: {
		name: "Elgyem",
	},
	beheeyem: {
		name: "Beheeyem",
	},
	litwick: {
		name: "Litwick",
	},
	lampent: {
		name: "Lampent",
	},
	chandelure: {
		name: "Chandelure",
	},
	axew: {
		name: "Axew",
	},
	fraxure: {
		name: "Fraxure",
	},
	haxorus: {
		name: "Haxorus",
	},
	cubchoo: {
		name: "Cubchoo",
	},
	beartic: {
		name: "Beartic",
	},
	cryogonal: {
		name: "Cryogonal",
	},
	shelmet: {
		name: "Shelmet",
	},
	accelgor: {
		name: "Accelgor",
	},
	stunfisk: {
		name: "Stunfisk",
	},
	stunfiskgalar: {
		name: "Stunfisk-Galar",
	},
	mienfoo: {
		name: "Mienfoo",
	},
	mienshao: {
		name: "Mienshao",
	},
	druddigon: {
		name: "Druddigon",
	},
	golett: {
		name: "Golett",
	},
	golurk: {
		name: "Golurk",
	},
	pawniard: {
		name: "Pawniard",
	},
	bisharp: {
		name: "Bisharp",
	},
	bouffalant: {
		name: "Bouffalant",
	},
	rufflet: {
		name: "Rufflet",
	},
	braviary: {
		name: "Braviary",
	},
	braviaryhisui: {
		name: "Braviary-Hisui",
	},
	vullaby: {
		name: "Vullaby",
	},
	mandibuzz: {
		name: "Mandibuzz",
	},
	heatmor: {
		name: "Heatmor",
	},
	durant: {
		name: "Durant",
	},
	deino: {
		name: "Deino",
	},
	zweilous: {
		name: "Zweilous",
	},
	hydreigon: {
		name: "Hydreigon",
	},
	larvesta: {
		name: "Larvesta",
	},
	volcarona: {
		name: "Volcarona",
	},
	cobalion: {
		name: "Cobalion",
	},
	terrakion: {
		name: "Terrakion",
	},
	virizion: {
		name: "Virizion",
	},
	tornadus: {
		name: "Tornadus",
	},
	tornadustherian: {
		name: "Tornadus-Therian",
	},
	thundurus: {
		name: "Thundurus",
	},
	thundurustherian: {
		name: "Thundurus-Therian",
	},
	reshiram: {
		name: "Reshiram",
	},
	zekrom: {
		name: "Zekrom",
	},
	landorus: {
		name: "Landorus",
	},
	landorustherian: {
		name: "Landorus-Therian",
	},
	kyurem: {
		name: "Kyurem",
	},
	kyuremblack: {
		name: "Kyurem-Black",
	},
	kyuremwhite: {
		name: "Kyurem-White",
	},
	keldeo: {
		name: "Keldeo",
	},
	keldeoresolute: {
		name: "Keldeo-Resolute",
	},
	meloetta: {
		name: "Meloetta",
	},
	meloettapirouette: {
		name: "Meloetta-Pirouette",
	},
	genesect: {
		name: "Genesect",
	},
	genesectdouse: {
		name: "Genesect-Douse",
	},
	genesectshock: {
		name: "Genesect-Shock",
	},
	genesectburn: {
		name: "Genesect-Burn",
	},
	genesectchill: {
		name: "Genesect-Chill",
	},
	chespin: {
		name: "Chespin",
	},
	quilladin: {
		name: "Quilladin",
	},
	chesnaught: {
		name: "Chesnaught",
	},
	fennekin: {
		name: "Fennekin",
	},
	braixen: {
		name: "Braixen",
	},
	delphox: {
		name: "Delphox",
	},
	froakie: {
		name: "Froakie",
	},
	frogadier: {
		name: "Frogadier",
	},
	greninja: {
		name: "Greninja",
	},
	greninjaash: {
		name: "Greninja-Ash",
	},
	bunnelby: {
		name: "Bunnelby",
	},
	diggersby: {
		name: "Diggersby",
	},
	fletchling: {
		name: "Fletchling",
	},
	fletchinder: {
		name: "Fletchinder",
	},
	talonflame: {
		name: "Talonflame",
	},
	scatterbug: {
		name: "Scatterbug",
	},
	spewpa: {
		name: "Spewpa",
	},
	vivillon: {
		name: "Vivillon",
	},
	vivillonfancy: {
		name: "Vivillon-Fancy",
	},
	vivillonpokeball: {
		name: "Vivillon-Pokeball",
	},
	litleo: {
		name: "Litleo",
	},
	pyroar: {
		name: "Pyroar",
	},
	flabebe: {
		name: "Flabe\u0301be\u0301",
	},
	floette: {
		name: "Floette",
	},
	floetteeternal: {
		name: "Floette-Eternal",
	},
	florges: {
		name: "Florges",
	},
	skiddo: {
		name: "Skiddo",
	},
	gogoat: {
		name: "Gogoat",
	},
	pancham: {
		name: "Pancham",
	},
	pangoro: {
		name: "Pangoro",
	},
	furfrou: {
		name: "Furfrou",
	},
	espurr: {
		name: "Espurr",
	},
	meowstic: {
		name: "Meowstic",
	},
	meowsticf: {
		name: "Meowstic-F",
	},
	honedge: {
		name: "Honedge",
	},
	doublade: {
		name: "Doublade",
	},
	aegislash: {
		name: "Aegislash",
	},
	aegislashblade: {
		name: "Aegislash-Blade",
	},
	spritzee: {
		name: "Spritzee",
	},
	aromatisse: {
		name: "Aromatisse",
	},
	swirlix: {
		name: "Swirlix",
	},
	slurpuff: {
		name: "Slurpuff",
	},
	inkay: {
		name: "Inkay",
	},
	malamar: {
		name: "Malamar",
	},
	binacle: {
		name: "Binacle",
	},
	barbaracle: {
		name: "Barbaracle",
	},
	skrelp: {
		name: "Skrelp",
	},
	dragalge: {
		name: "Dragalge",
	},
	clauncher: {
		name: "Clauncher",
	},
	clawitzer: {
		name: "Clawitzer",
	},
	helioptile: {
		name: "Helioptile",
	},
	heliolisk: {
		name: "Heliolisk",
	},
	tyrunt: {
		name: "Tyrunt",
	},
	tyrantrum: {
		name: "Tyrantrum",
	},
	amaura: {
		name: "Amaura",
	},
	aurorus: {
		name: "Aurorus",
	},
	sylveon: {
		name: "Sylveon",
	},
	hawlucha: {
		name: "Hawlucha",
	},
	dedenne: {
		name: "Dedenne",
	},
	carbink: {
		name: "Carbink",
	},
	goomy: {
		name: "Goomy",
	},
	sliggoo: {
		name: "Sliggoo",
	},
	sliggoohisui: {
		name: "Sliggoo-Hisui",
	},
	goodra: {
		name: "Goodra",
	},
	goodrahisui: {
		name: "Goodra-Hisui",
	},
	klefki: {
		name: "Klefki",
	},
	phantump: {
		name: "Phantump",
	},
	trevenant: {
		name: "Trevenant",
	},
	pumpkaboo: {
		name: "Pumpkaboo",
	},
	pumpkaboosmall: {
		name: "Pumpkaboo-Small",
	},
	pumpkaboolarge: {
		name: "Pumpkaboo-Large",
	},
	pumpkaboosuper: {
		name: "Pumpkaboo-Super",
	},
	gourgeist: {
		name: "Gourgeist",
	},
	gourgeistsmall: {
		name: "Gourgeist-Small",
	},
	gourgeistlarge: {
		name: "Gourgeist-Large",
	},
	gourgeistsuper: {
		name: "Gourgeist-Super",
	},
	bergmite: {
		name: "Bergmite",
	},
	avalugg: {
		name: "Avalugg",
	},
	avalugghisui: {
		name: "Avalugg-Hisui",
	},
	noibat: {
		name: "Noibat",
	},
	noivern: {
		name: "Noivern",
	},
	xerneas: {
		name: "Xerneas",
	},
	xerneasneutral: {
		name: "Xerneas-Neutral",
	},
	yveltal: {
		name: "Yveltal",
	},
	zygarde: {
		name: "Zygarde",
	},
	zygarde10: {
		name: "Zygarde-10%",
	},
	zygardecomplete: {
		name: "Zygarde-Complete",
	},
	diancie: {
		name: "Diancie",
	},
	dianciemega: {
		name: "Diancie-Mega",
	},
	hoopa: {
		name: "Hoopa",
	},
	hoopaunbound: {
		name: "Hoopa-Unbound",
	},
	volcanion: {
		name: "Volcanion",
	},
	rowlet: {
		name: "Rowlet",
	},
	dartrix: {
		name: "Dartrix",
	},
	decidueye: {
		name: "Decidueye",
	},
	decidueyehisui: {
		name: "Decidueye-Hisui",
	},
	litten: {
		name: "Litten",
	},
	torracat: {
		name: "Torracat",
	},
	incineroar: {
		name: "Incineroar",
	},
	popplio: {
		name: "Popplio",
	},
	brionne: {
		name: "Brionne",
	},
	primarina: {
		name: "Primarina",
	},
	pikipek: {
		name: "Pikipek",
	},
	trumbeak: {
		name: "Trumbeak",
	},
	toucannon: {
		name: "Toucannon",
	},
	yungoos: {
		name: "Yungoos",
	},
	gumshoos: {
		name: "Gumshoos",
	},
	gumshoostotem: {
		name: "Gumshoos-Totem",
	},
	grubbin: {
		name: "Grubbin",
	},
	charjabug: {
		name: "Charjabug",
	},
	vikavolt: {
		name: "Vikavolt",
	},
	vikavolttotem: {
		name: "Vikavolt-Totem",
	},
	crabrawler: {
		name: "Crabrawler",
	},
	crabominable: {
		name: "Crabominable",
	},
	oricorio: {
		name: "Oricorio",
	},
	oricoriopompom: {
		name: "Oricorio-Pom-Pom",
	},
	oricoriopau: {
		name: "Oricorio-Pa'u",
	},
	oricoriosensu: {
		name: "Oricorio-Sensu",
	},
	cutiefly: {
		name: "Cutiefly",
	},
	ribombee: {
		name: "Ribombee",
	},
	ribombeetotem: {
		name: "Ribombee-Totem",
	},
	rockruff: {
		name: "Rockruff",
	},
	lycanroc: {
		name: "Lycanroc",
	},
	lycanrocmidnight: {
		name: "Lycanroc-Midnight",
	},
	lycanrocdusk: {
		name: "Lycanroc-Dusk",
	},
	wishiwashi: {
		name: "Wishiwashi",
	},
	wishiwashischool: {
		name: "Wishiwashi-School",
	},
	mareanie: {
		name: "Mareanie",
	},
	toxapex: {
		name: "Toxapex",
	},
	mudbray: {
		name: "Mudbray",
	},
	mudsdale: {
		name: "Mudsdale",
	},
	dewpider: {
		name: "Dewpider",
	},
	araquanid: {
		name: "Araquanid",
	},
	araquanidtotem: {
		name: "Araquanid-Totem",
	},
	fomantis: {
		name: "Fomantis",
	},
	lurantis: {
		name: "Lurantis",
	},
	lurantistotem: {
		name: "Lurantis-Totem",
	},
	morelull: {
		name: "Morelull",
	},
	shiinotic: {
		name: "Shiinotic",
	},
	salandit: {
		name: "Salandit",
	},
	salazzle: {
		name: "Salazzle",
	},
	salazzletotem: {
		name: "Salazzle-Totem",
	},
	stufful: {
		name: "Stufful",
	},
	bewear: {
		name: "Bewear",
	},
	bounsweet: {
		name: "Bounsweet",
	},
	steenee: {
		name: "Steenee",
	},
	tsareena: {
		name: "Tsareena",
	},
	comfey: {
		name: "Comfey",
	},
	oranguru: {
		name: "Oranguru",
	},
	passimian: {
		name: "Passimian",
	},
	wimpod: {
		name: "Wimpod",
	},
	golisopod: {
		name: "Golisopod",
	},
	sandygast: {
		name: "Sandygast",
	},
	palossand: {
		name: "Palossand",
	},
	pyukumuku: {
		name: "Pyukumuku",
	},
	typenull: {
		name: "Type: Null",
	},
	silvally: {
		name: "Silvally",
	},
	silvallybug: {
		name: "Silvally-Bug",
	},
	silvallydark: {
		name: "Silvally-Dark",
	},
	silvallydragon: {
		name: "Silvally-Dragon",
	},
	silvallyelectric: {
		name: "Silvally-Electric",
	},
	silvallyfairy: {
		name: "Silvally-Fairy",
	},
	silvallyfighting: {
		name: "Silvally-Fighting",
	},
	silvallyfire: {
		name: "Silvally-Fire",
	},
	silvallyflying: {
		name: "Silvally-Flying",
	},
	silvallyghost: {
		name: "Silvally-Ghost",
	},
	silvallygrass: {
		name: "Silvally-Grass",
	},
	silvallyground: {
		name: "Silvally-Ground",
	},
	silvallyice: {
		name: "Silvally-Ice",
	},
	silvallypoison: {
		name: "Silvally-Poison",
	},
	silvallypsychic: {
		name: "Silvally-Psychic",
	},
	silvallyrock: {
		name: "Silvally-Rock",
	},
	silvallysteel: {
		name: "Silvally-Steel",
	},
	silvallywater: {
		name: "Silvally-Water",
	},
	minior: {
		name: "Minior",
	},
	miniormeteor: {
		name: "Minior-Meteor",
	},
	komala: {
		name: "Komala",
	},
	turtonator: {
		name: "Turtonator",
	},
	togedemaru: {
		name: "Togedemaru",
	},
	togedemarutotem: {
		name: "Togedemaru-Totem",
	},
	mimikyu: {
		name: "Mimikyu",
	},
	mimikyubusted: {
		name: "Mimikyu-Busted",
	},
	mimikyutotem: {
		name: "Mimikyu-Totem",
	},
	mimikyubustedtotem: {
		name: "Mimikyu-Busted-Totem",
	},
	bruxish: {
		name: "Bruxish",
	},
	drampa: {
		name: "Drampa",
	},
	dhelmise: {
		name: "Dhelmise",
	},
	jangmoo: {
		name: "Jangmo-o",
	},
	hakamoo: {
		name: "Hakamo-o",
	},
	kommoo: {
		name: "Kommo-o",
	},
	kommoototem: {
		name: "Kommo-o-Totem",
	},
	tapukoko: {
		name: "Tapu Koko",
	},
	tapulele: {
		name: "Tapu Lele",
	},
	tapubulu: {
		name: "Tapu Bulu",
	},
	tapufini: {
		name: "Tapu Fini",
	},
	cosmog: {
		name: "Cosmog",
	},
	cosmoem: {
		name: "Cosmoem",
	},
	solgaleo: {
		name: "Solgaleo",
	},
	lunala: {
		name: "Lunala",
	},
	nihilego: {
		name: "Nihilego",
	},
	buzzwole: {
		name: "Buzzwole",
	},
	pheromosa: {
		name: "Pheromosa",
	},
	xurkitree: {
		name: "Xurkitree",
	},
	celesteela: {
		name: "Celesteela",
	},
	kartana: {
		name: "Kartana",
	},
	guzzlord: {
		name: "Guzzlord",
	},
	necrozma: {
		name: "Necrozma",
	},
	necrozmaduskmane: {
		name: "Necrozma-Dusk-Mane",
	},
	necrozmadawnwings: {
		name: "Necrozma-Dawn-Wings",
	},
	necrozmaultra: {
		name: "Necrozma-Ultra",
	},
	magearna: {
		name: "Magearna",
	},
	magearnaoriginal: {
		name: "Magearna-Original",
	},
	marshadow: {
		name: "Marshadow",
	},
	poipole: {
		name: "Poipole",
	},
	naganadel: {
		name: "Naganadel",
	},
	stakataka: {
		name: "Stakataka",
	},
	blacephalon: {
		name: "Blacephalon",
	},
	zeraora: {
		name: "Zeraora",
	},
	meltan: {
		name: "Meltan",
	},
	melmetal: {
		name: "Melmetal",
	},
	melmetalgmax: {
		name: "Melmetal-Gmax",
	},
	grookey: {
		name: "Grookey",
	},
	thwackey: {
		name: "Thwackey",
	},
	rillaboom: {
		name: "Rillaboom",
	},
	rillaboomgmax: {
		name: "Rillaboom-Gmax",
	},
	scorbunny: {
		name: "Scorbunny",
	},
	raboot: {
		name: "Raboot",
	},
	cinderace: {
		name: "Cinderace",
	},
	cinderacegmax: {
		name: "Cinderace-Gmax",
	},
	sobble: {
		name: "Sobble",
	},
	drizzile: {
		name: "Drizzile",
	},
	inteleon: {
		name: "Inteleon",
	},
	inteleongmax: {
		name: "Inteleon-Gmax",
	},
	skwovet: {
		name: "Skwovet",
	},
	greedent: {
		name: "Greedent",
	},
	rookidee: {
		name: "Rookidee",
	},
	corvisquire: {
		name: "Corvisquire",
	},
	corviknight: {
		name: "Corviknight",
	},
	corviknightgmax: {
		name: "Corviknight-Gmax",
	},
	blipbug: {
		name: "Blipbug",
	},
	dottler: {
		name: "Dottler",
	},
	orbeetle: {
		name: "Orbeetle",
	},
	orbeetlegmax: {
		name: "Orbeetle-Gmax",
	},
	nickit: {
		name: "Nickit",
	},
	thievul: {
		name: "Thievul",
	},
	gossifleur: {
		name: "Gossifleur",
	},
	eldegoss: {
		name: "Eldegoss",
	},
	wooloo: {
		name: "Wooloo",
	},
	dubwool: {
		name: "Dubwool",
	},
	chewtle: {
		name: "Chewtle",
	},
	drednaw: {
		name: "Drednaw",
	},
	drednawgmax: {
		name: "Drednaw-Gmax",
	},
	yamper: {
		name: "Yamper",
	},
	boltund: {
		name: "Boltund",
	},
	rolycoly: {
		name: "Rolycoly",
	},
	carkol: {
		name: "Carkol",
	},
	coalossal: {
		name: "Coalossal",
	},
	coalossalgmax: {
		name: "Coalossal-Gmax",
	},
	applin: {
		name: "Applin",
	},
	flapple: {
		name: "Flapple",
	},
	flapplegmax: {
		name: "Flapple-Gmax",
	},
	appletun: {
		name: "Appletun",
	},
	appletungmax: {
		name: "Appletun-Gmax",
	},
	silicobra: {
		name: "Silicobra",
	},
	sandaconda: {
		name: "Sandaconda",
	},
	sandacondagmax: {
		name: "Sandaconda-Gmax",
	},
	cramorant: {
		name: "Cramorant",
	},
	cramorantgulping: {
		name: "Cramorant-Gulping",
	},
	cramorantgorging: {
		name: "Cramorant-Gorging",
	},
	arrokuda: {
		name: "Arrokuda",
	},
	barraskewda: {
		name: "Barraskewda",
	},
	toxel: {
		name: "Toxel",
	},
	toxtricity: {
		name: "Toxtricity",
	},
	toxtricitylowkey: {
		name: "Toxtricity-Low-Key",
	},
	toxtricitygmax: {
		name: "Toxtricity-Gmax",
	},
	toxtricitylowkeygmax: {
		name: "Toxtricity-Low-Key-Gmax",
	},
	sizzlipede: {
		name: "Sizzlipede",
	},
	centiskorch: {
		name: "Centiskorch",
	},
	centiskorchgmax: {
		name: "Centiskorch-Gmax",
	},
	clobbopus: {
		name: "Clobbopus",
	},
	grapploct: {
		name: "Grapploct",
	},
	sinistea: {
		name: "Sinistea",
	},
	sinisteaantique: {
		name: "Sinistea-Antique",
	},
	polteageist: {
		name: "Polteageist",
	},
	polteageistantique: {
		name: "Polteageist-Antique",
	},
	hatenna: {
		name: "Hatenna",
	},
	hattrem: {
		name: "Hattrem",
	},
	hatterene: {
		name: "Hatterene",
	},
	hatterenegmax: {
		name: "Hatterene-Gmax",
	},
	impidimp: {
		name: "Impidimp",
	},
	morgrem: {
		name: "Morgrem",
	},
	grimmsnarl: {
		name: "Grimmsnarl",
	},
	grimmsnarlgmax: {
		name: "Grimmsnarl-Gmax",
	},
	obstagoon: {
		name: "Obstagoon",
	},
	perrserker: {
		name: "Perrserker",
	},
	cursola: {
		name: "Cursola",
	},
	sirfetchd: {
		name: "Sirfetch\u2019d",
	},
	mrrime: {
		name: "Mr. Rime",
	},
	runerigus: {
		name: "Runerigus",
	},
	milcery: {
		name: "Milcery",
	},
	alcremie: {
		name: "Alcremie",
	},
	alcremiegmax: {
		name: "Alcremie-Gmax",
	},
	falinks: {
		name: "Falinks",
	},
	pincurchin: {
		name: "Pincurchin",
	},
	snom: {
		name: "Snom",
	},
	frosmoth: {
		name: "Frosmoth",
	},
	stonjourner: {
		name: "Stonjourner",
	},
	eiscue: {
		name: "Eiscue",
	},
	eiscuenoice: {
		name: "Eiscue-Noice",
	},
	indeedee: {
		name: "Indeedee",
	},
	indeedeef: {
		name: "Indeedee-F",
	},
	morpeko: {
		name: "Morpeko",
	},
	morpekohangry: {
		name: "Morpeko-Hangry",
	},
	cufant: {
		name: "Cufant",
	},
	copperajah: {
		name: "Copperajah",
	},
	copperajahgmax: {
		name: "Copperajah-Gmax",
	},
	dracozolt: {
		name: "Dracozolt",
	},
	arctozolt: {
		name: "Arctozolt",
	},
	dracovish: {
		name: "Dracovish",
	},
	arctovish: {
		name: "Arctovish",
	},
	duraludon: {
		name: "Duraludon",
	},
	duraludongmax: {
		name: "Duraludon-Gmax",
	},
	dreepy: {
		name: "Dreepy",
	},
	drakloak: {
		name: "Drakloak",
	},
	dragapult: {
		name: "Dragapult",
	},
	zacian: {
		name: "Zacian",
	},
	zaciancrowned: {
		name: "Zacian-Crowned",
	},
	zamazenta: {
		name: "Zamazenta",
	},
	zamazentacrowned: {
		name: "Zamazenta-Crowned",
	},
	eternatus: {
		name: "Eternatus",
	},
	eternatuseternamax: {
		name: "Eternatus-Eternamax",
	},
	kubfu: {
		name: "Kubfu",
	},
	urshifu: {
		name: "Urshifu",
	},
	urshifurapidstrike: {
		name: "Urshifu-Rapid-Strike",
	},
	urshifugmax: {
		name: "Urshifu-Gmax",
	},
	urshifurapidstrikegmax: {
		name: "Urshifu-Rapid-Strike-Gmax",
	},
	zarude: {
		name: "Zarude",
	},
	zarudedada: {
		name: "Zarude-Dada",
	},
	regieleki: {
		name: "Regieleki",
	},
	regidrago: {
		name: "Regidrago",
	},
	glastrier: {
		name: "Glastrier",
	},
	spectrier: {
		name: "Spectrier",
	},
	calyrex: {
		name: "Calyrex",
	},
	calyrexice: {
		name: "Calyrex-Ice",
	},
	calyrexshadow: {
		name: "Calyrex-Shadow",
	},
	wyrdeer: {
		name: "Wydreer",
	},
	kleavor: {
		name: "Kleavor",
	},
	ursaluna: {
		name: "Ursaluna",
	},
	basculegion: {
		name: "Basculegion",
	},
	basculegionf: {
		name: "Basculegion-F",
	},
	sneasler: {
		name: "Sneasler",
	},
	overqwil: {
		name: "Overqwil",
	},
	enamorus: {
		name: "Enamorus",
	},
	enamorustherian: {
		name: "Enamorus-Therian",
	},
	missingno: {
		name: "MissingNo.",
	},
	syclar: {
		name: "Syclar",
	},
	syclant: {
		name: "Syclant",
	},
	revenankh: {
		name: "Revenankh",
	},
	embirch: {
		name: "Embirch",
	},
	flarelm: {
		name: "Flarelm",
	},
	pyroak: {
		name: "Pyroak",
	},
	breezi: {
		name: "Breezi",
	},
	fidgit: {
		name: "Fidgit",
	},
	rebble: {
		name: "Rebble",
	},
	tactite: {
		name: "Tactite",
	},
	stratagem: {
		name: "Stratagem",
	},
	privatyke: {
		name: "Privatyke",
	},
	arghonaut: {
		name: "Arghonaut",
	},
	kitsunoh: {
		name: "Kitsunoh",
	},
	cyclohm: {
		name: "Cyclohm",
	},
	colossoil: {
		name: "Colossoil",
	},
	krilowatt: {
		name: "Krilowatt",
	},
	voodoll: {
		name: "Voodoll",
	},
	voodoom: {
		name: "Voodoom",
	},
	scratchet: {
		name: "Scratchet",
	},
	tomohawk: {
		name: "Tomohawk",
	},
	necturine: {
		name: "Necturine",
	},
	necturna: {
		name: "Necturna",
	},
	mollux: {
		name: "Mollux",
	},
	cupra: {
		name: "Cupra",
	},
	argalis: {
		name: "Argalis",
	},
	aurumoth: {
		name: "Aurumoth",
	},
	brattler: {
		name: "Brattler",
	},
	malaconda: {
		name: "Malaconda",
	},
	cawdet: {
		name: "Cawdet",
	},
	cawmodore: {
		name: "Cawmodore",
	},
	volkritter: {
		name: "Volkritter",
	},
	volkraken: {
		name: "Volkraken",
	},
	snugglow: {
		name: "Snugglow",
	},
	plasmanta: {
		name: "Plasmanta",
	},
	floatoy: {
		name: "Floatoy",
	},
	caimanoe: {
		name: "Caimanoe",
	},
	naviathan: {
		name: "Naviathan",
	},
	crucibelle: {
		name: "Crucibelle",
	},
	crucibellemega: {
		name: "Crucibelle-Mega",
	},
	pluffle: {
		name: "Pluffle",
	},
	kerfluffle: {
		name: "Kerfluffle",
	},
	pajantom: {
		name: "Pajantom",
	},
	mumbao: {
		name: "Mumbao",
	},
	jumbao: {
		name: "Jumbao",
	},
	fawnifer: {
		name: "Fawnifer",
	},
	electrelk: {
		name: "Electrelk",
	},
	caribolt: {
		name: "Caribolt",
	},
	smogecko: {
		name: "Smogecko",
	},
	smoguana: {
		name: "Smoguana",
	},
	smokomodo: {
		name: "Smokomodo",
	},
	swirlpool: {
		name: "Swirlpool",
	},
	coribalis: {
		name: "Coribalis",
	},
	snaelstrom: {
		name: "Snaelstrom",
	},
	equilibra: {
		name: "Equilibra",
	},
	astrolotl: {
		name: "Astrolotl",
	},
	pokestarsmeargle: {
		name: "Pokestar Smeargle",
	},
	pokestarufo: {
		name: "Pokestar UFO",
	},
	pokestarufo2: {
		name: "Pokestar UFO-2",
	},
	pokestarbrycenman: {
		name: "Pokestar Brycen-Man",
	},
	pokestarmt: {
		name: "Pokestar MT",
	},
	pokestarmt2: {
		name: "Pokestar MT2",
	},
	pokestartransport: {
		name: "Pokestar Transport",
	},
	pokestargiant: {
		name: "Pokestar Giant",
	},
	pokestarhumanoid: {
		name: "Pokestar Humanoid",
	},
	pokestarmonster: {
		name: "Pokestar Monster",
	},
	pokestarf00: {
		name: "Pokestar F-00",
	},
	pokestarf002: {
		name: "Pokestar F-002",
	},
	pokestarspirit: {
		name: "Pokestar Spirit",
	},
	pokestarblackdoor: {
		name: "Pokestar Black Door",
	},
	pokestarwhitedoor: {
		name: "Pokestar White Door",
	},
	pokestarblackbelt: {
		name: "Pokestar Black Belt",
	},
	pokestarufopropu2: {
		name: "Pokestar UFO-PropU2",
	},
};
